<div fxFlex fxLayout="column" fxLayoutAlign="start left">
	<div class="mr-3">
		<span class="doctor-title">{{ 'DoctorSection.Doctor' | translate}}:</span>
	</div>
	<div>
		<span class="doctor-name">{{doctorName}}</span>
	</div>
</div>